export { Ctextinput, TextInputMode } from './Ctextinput';
export type { CtextinputProps } from './Ctextinput';

